import { AgGridReact } from 'ag-grid-react';
import { Badge, Breadcrumb, Button, ConfigProvider, Pagination, Tag, Tooltip } from 'antd';
import React, { useEffect, useMemo, useState } from 'react'
import { NodataTable } from '../../../components/NoDataTable';
import { capitalizeEachWord, CustomLoadingOverlayTable, dataPagination } from '../../../until';
import viVN from 'antd/locale/vi_VN';
import { formatNumber } from '../../../services/mixin';
import * as IssuedCardsApi from '../../../api/rank/issuedCardApi';
import { ColDef } from 'ag-grid-community';
import { NO_DATA, URL_RANK } from '../../../env';
import { none_rank } from '../../../components/ExportImgFigma';
import Layout from '../../../Layout';
import { exportReportMemberCardList, getReportMemberCardList, IReportMemberCardList } from '../../../api/reportCustomer/reportCustomerApi';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { Link, useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { DownloadOutlined } from '@ant-design/icons';

const ReportMemberCardList = () => {

    const pushToast = useToast()
    const location = useLocation();
    const navigate = useNavigate();

    const { type,
        unitScopeId, businessCheck, gender, statusMarital,
        ageGroup, provinceId, professionId,
        listUnit, listRank,
        fromMonth, toMonth, year, title } = location?.state ?? {}


    const [loadingTable, setLoadingTable] = useState(false)
    const [isExporting, setIsExporting] = useState(false)

    const [dataReportMemberCardList, setDataReportMemberCardList] = useState<IssuedCardsApi.DataTypeIssuedCards[]>([])
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const columnDefs = useMemo<ColDef<IssuedCardsApi.DataTypeIssuedCards>[]>(() => [
        {
            headerName: 'Mã thẻ',
            field: 'mt',
            width: 140,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                return record.status === 2 || record.status === 3
                    ? <span className="t-op-40">Chưa phát hành</span>
                    : <span>{p.value}</span>;
            },
        },
        {
            headerName: 'Tên khách hàng/Tổ chức',
            field: 'name',
            minWidth: 180,
            resizable: true,
            flex: 1,
            cellRenderer: (p: any) => <span>{capitalizeEachWord(p.value)}</span>,
        },
        {
            headerName: 'Hạng thẻ',
            field: 'ht',
            width: 160,
            sortable: true,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                if (record.status === 2 || record.status === 3) {
                    return (
                        <div className="ctrl-title-ht">
                            <div className="img-box"><img src={none_rank} style={{ width: 20, height: 20, objectFit: 'cover' }} alt="" /></div>
                            <span className="t-op-40">Chưa phát hành</span>
                        </div>
                    );
                }
                return (
                    <div className="ctrl-title-ht">
                        <div className="img-box">
                            <img src={URL_RANK + record.icon} style={{ width: 20, height: 20, objectFit: 'cover' }} onError={(e) => { e.currentTarget.src = none_rank; }} alt="" />
                        </div>
                        <span className="text">{p.value}</span>
                    </div>
                );
            },
        },
        {
            headerName: 'Ngày phát hành',
            field: 'nph',
            width: 150,
            sortable: true,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                return record.status === 2 || record.status === 3
                    ? <span className="t-op-40">Chưa phát hành</span>
                    : <span>{p.value}</span>;
            },
        },
        {
            headerName: 'Ngày hết hạn',
            field: 'nhh',
            width: 150,
            sortable: true,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                return record.status === 2 || record.status === 3
                    ? <span className="t-op-40">Chưa phát hành</span>
                    : <span>{p.value}</span>;
            },
        },
        {
            headerName: 'Trạng thái',
            field: 'status',
            width: 140,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                if (record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
                if (record.status === 1) return <Badge status="success" text="Hoạt động" />;
                if (record.status === 0) return <Badge status="warning" text="Tạm khóa" />;
                if (record.status === 2) return <Badge status="error" className="t-op-40" text="Hết hạn" />;
                return null;
            },
        },
        {
            headerName: 'Chính sách CSKH',
            field: 'listCarePolicies' as any,
            minWidth: 160,
            resizable: true,
            flex: 1,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                if (record.status === 2 || record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
                return (
                    <Tooltip title={p.value}>
                        <div style={{ display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'break-word' }}>
                            {p.value || NO_DATA}
                        </div>
                    </Tooltip>
                );
            },
        },
        {
            headerName: 'Nguồn phát',
            field: 'addType',
            width: 130,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                if (record.status === 2 || record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
                if (p.value === 0) return <Tag color="green">Thủ công</Tag>;
                if (p.value === 1) return <Tag color="blue">Tự động</Tag>;
                return <span>{NO_DATA}</span>;
            },
        },
        {
            headerName: 'Số điểm tích lũy hiện tại',
            field: 'point',
            width: 190,
            resizable: true,
            cellRenderer: (p: any) => {
                const record: IssuedCardsApi.DataTypeIssuedCards = p.data;
                if (record.status === 2 || record.status === 3) return <span className="t-op-40">Chưa phát hành</span>;
                return <span>{p.value !== undefined ? formatNumber(p.value) : NO_DATA}</span>;
            },
        },
    ], []);


    const gListReportMemberCardList = useDebounce(async (limit: number = 10, pageNumber: number = 1) => {
        setLoadingTable(true)
        const result = await getReportMemberCardList(
            limit, pageNumber, type,
            unitScopeId, businessCheck, gender, statusMarital,
            ageGroup, provinceId, professionId,
            listUnit, listRank,
            fromMonth, toMonth, year
        );
        if (result?.status) {
            setDataReportMemberCardList(convertData(result.data))
            setPagination({ current: pageNumber, total: result.total, pageSize: limit })
            // setPaginationTmp(pageNumber)
        } else {
            pushToast(result?.message, "error", 2000)
        }
        setLoadingTable(false)
    }, 1000)

    const convertData = (data: IReportMemberCardList[]) => {


        const convertData = data?.map((item) => ({
            key: item.id,
            mt: item.codeCard,
            name: item.name,
            ht: item.rank.title,
            nph: item.releaseDate,
            nhh: item.expirationDate,
            status: item.status,
            icon: item.rank.icon,
            listCarePolicies: item.listCarePolicies,
            addType: item.addType,
        }
        ))
        return convertData
    }


    const handleExportExcel = async () => {
        setIsExporting(true)
        await exportReportMemberCardList(
            type,
            unitScopeId, businessCheck, gender, statusMarital,
            ageGroup, provinceId, professionId,
            listUnit, listRank,
            fromMonth, toMonth, year
        )
        setIsExporting(false)
    }

    const handleChangePagination = (current: number, pageSize: number, typeCard?: number, rankId?: number, search?: string) => {
        setPagination((prev) => ({ ...prev, current: current, pageSize }))
        gListReportMemberCardList(pageSize, current)
    }


    useEffect(() => {
        if (type === undefined) {
            navigate(-1)
        } else {
            gListReportMemberCardList()
        }
    }, [location])


    return (
        <div className='card-issuance-list'>
            <Layout>

                <Breadcrumb
                    items={[
                        {
                            title: 'THACO AUTO CRM',
                        },
                        {
                            title: <a href="/">Báo cáo phân tích</a>,
                        },
                        {
                            title: 'Tổng quan thành viên theo phân hạng',
                        },
                        {
                            title: 'Phát hành thẻ',
                        },
                    ]}
                />

                <div className=' custom-page-css flex items-center gap-2'>
                    <Link to="/analysis-report/membership-tier" className="icon-svg pb-1">
                        <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6564 7.80321H4.04305L10.3955 2.37463C10.4971 2.28713 10.4354 2.12463 10.3012 2.12463H8.69582C8.62508 2.12463 8.55796 2.14963 8.50536 2.19428L1.65045 8.04963C1.58767 8.10321 1.53732 8.16944 1.50281 8.24385C1.4683 8.31825 1.45044 8.39909 1.45044 8.48088C1.45044 8.56268 1.4683 8.64352 1.50281 8.71792C1.53732 8.79233 1.58767 8.85856 1.65045 8.91213L8.54526 14.8032C8.57247 14.8264 8.60512 14.8389 8.63959 14.8389H10.2993C10.4336 14.8389 10.4953 14.6746 10.3937 14.5889L4.04305 9.16035H14.6564C14.7363 9.16035 14.8016 9.09606 14.8016 9.01749V7.94606C14.8016 7.86749 14.7363 7.80321 14.6564 7.80321Z" fill="currentColor" fillOpacity="0.88" />
                        </svg>
                    </Link>
                    <span className='title-page'>   Phát hành thẻ</span>
                </div>

                <div className="custom-page-css w-full flex items-center justify-between pb-2">
                    <span>{title}</span>
                    <Button
                        icon={<DownloadOutlined />}
                        loading={isExporting}
                        onClick={handleExportExcel}
                    >
                        Xuất báo cáo
                    </Button>
                </div>
            
                <div className="t-table-block custom-page-css flex flex-col flex-1 justify-between">
                    <div className="ag-theme-alpine empty-test-td custom-table-ag-v2" style={{ width: '100%' }}>
                        <AgGridReact
                            domLayout="autoHeight"
                            rowData={dataReportMemberCardList}
                            columnDefs={columnDefs}
                            defaultColDef={{ resizable: true, sortable: false }}
                            loading={loadingTable}
                            getRowId={(params) => params.data.key.toString()}
                            suppressDragLeaveHidesColumns
                            loadingOverlayComponent={CustomLoadingOverlayTable}
                            overlayNoRowsTemplate={NodataTable}
                            rowHeight={55}
                            getRowStyle={(params: any) => ({
                                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                            })}
                        />
                    </div>
                    <ConfigProvider locale={viVN}>
                        <div className="pagination-block flex justify-center">

                            <Pagination
                                total={pagination.total}
                                current={pagination.current}
                                pageSize={pagination.pageSize}
                                showSizeChanger
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                                locale={{ items_per_page: 'trang' }}
                                onChange={handleChangePagination}
                            />
                        </div>
                    </ConfigProvider>
                </div>


            </Layout >
        </div >
    )
}
export default ReportMemberCardList